import LoadingIndicator from '@alchemer/ui-deprecated/loading-indicator';
import { PlatformLoader } from '@alchemer/unified-platform/platformLoader';
import { useFlag } from '@alchemer/unleash';
import { FEATURE_FLAGS } from '@/config/features';

export const LoadingView = () => {
  const isUnifiedIntegrationEnabled = useFlag(FEATURE_FLAGS.UNIFIED_INTEGRATION);

  // Branded full-screen overlay for the unified shell; covers the header too.
  if (isUnifiedIntegrationEnabled) return <PlatformLoader />;

  return (
    <div className="flex h-full items-center justify-center">
      <LoadingIndicator aria-label="Loading application" />
    </div>
  );
};
